import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetRevisionLicensesResponse } from '../../../../shared/licenses/response';

const STALE_TIME = 1000 * 30; // 30 seconds

async function getRevisionLicenses(locator: string) {
  return get<GetRevisionLicensesResponse>(`/api/revisions/${nuc(locator)}/licenses`);
}

export const getQueryKey = (locator: string): QueryKey => ['revisions', locator, 'licenses'];

/**
 * Hook to fetch licenses for a revision.
 *
 * @param {string} locator The revision locator.
 * @param {boolean} shouldFetch Whether to fetch the data. Defaults to true.
 */
export function useRevisionLicenses(locator: string, shouldFetch = true) {
  return useQuery<GetRevisionLicensesResponse>({
    queryKey: getQueryKey(locator),
    queryFn: () => getRevisionLicenses(locator),
    staleTime: STALE_TIME,
    enabled: shouldFetch && !!locator,
  });
}
